import * as React from 'react'
import { inject, observer } from "mobx-react"
import { WrappedComponentProps, injectIntl } from 'react-intl'

import './ReportsFiltering.scss'

import { ReportState } from "../../ReportsEnums"
import ReportsFilteringMenu from "./ReportsFilteringMenu"
import ReportsFilteringSelect from "./ReportsFilteringSelect"
import RootStore from '../../../../../../stores/RootStore'

export interface ReportsFilteringProps {
	rootStore?: RootStore
}
export interface ReportsFilteringListProps {
	doneTitle: string,
	ongoingTitle: string,
	awaitingTitle: string,
	archivedTitle: string,
	activeStateFilter: ReportState,
	setFilterCallback: Function
}

const ReportsFiltering: React.FunctionComponent<ReportsFilteringProps & WrappedComponentProps> = props => {
	const store = props.rootStore!.clientViewStore!;
	const reportsStore = store.reportsStore;
	const { activeStateFilter } = reportsStore;
	const setFilterCallback = async (val: ReportState) => {
       store.loading = true
       setTimeout(async () => {
        reportsStore.activeStateFilter = val;
        await reportsStore.init()
        store.loading = false
       }, 200);
	};

	const doneTitleId = (reportsStore.numberOfDelivered > 0) ? 'client.reports.filter.done' : 'client.reports.filter.done.clean';
	const ongoingTitleId = (reportsStore.numberOfOngoing > 0) ? 'client.reports.filter.ongoing' : 'client.reports.filter.ongoing.clean';
	const awaitingTitleId = (reportsStore.numberOfWaitingApproval > 0) ? 'client.reports.filter.waiting' : 'client.reports.filter.waiting.clean';
	
	const doneTitle = props.intl.formatMessage({ id: doneTitleId }, { num: reportsStore.numberOfDelivered });
	const ongoingTitle = props.intl.formatMessage({ id: ongoingTitleId }, { num: reportsStore.numberOfOngoing });
	const awaitingTitle = props.intl.formatMessage({ id: awaitingTitleId }, { num: reportsStore.numberOfWaitingApproval });
	const archivedTitle = props.intl.formatMessage({ id: 'client.reports.filter.archive' });

	const filteringProps = { doneTitle, ongoingTitle, awaitingTitle, archivedTitle, activeStateFilter, setFilterCallback };
	return (
		<React.Fragment>
			<ReportsFilteringMenu {...filteringProps} />
			<ReportsFilteringSelect {...filteringProps} />
		</React.Fragment>
	);
};

export default injectIntl(inject('rootStore')(observer(ReportsFiltering)));
